var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserCommunications',{attrs:{"user-id":_vm.id,"recipient-type":"contractor","recipient-label":"исполнителю"}})}
var staticRenderFns = []

export { render, staticRenderFns }